import {
  parseBooleanEnabledSOC,
  parseNumberSOC,
} from "src/core/pushNotification/imports/abTests";

export const getIsPWANotificationBannerEnabled = parseBooleanEnabledSOC(
  "web.pwa.notification.banner.enabled",
  "0"
);

export const getPushNotificationClickDelayMS = parseNumberSOC(
  "web.push.notification.click.delay.ms",
  "1000"
);
